import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
export function useBodyScrollLock(isLocked) {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== isLocked) {
    t0 = () => {
      if (!isLocked) {
        return;
      }
      const previous = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = previous;
      };
    };
    t1 = [isLocked];
    $[0] = isLocked;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}